import React from "react";
import { Check, CheckCheck, Clock3, UserRound } from "lucide-react";
import { capitalizeName } from "src/utils/getInitials";
import { Monogram } from "src/stage/StageUi";

// AUTO-WA-39: one chat in the list — who, the last message, when, unread
// count, up to two tags and who owns it.

/** WhatsApp-style list timestamp: time if today, "Yesterday", weekday, else date. */
export function listTime(value, now = new Date()) {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  if (d.toDateString() === now.toDateString()) {
    return d.toLocaleTimeString("en-IN", { hour: "numeric", minute: "2-digit", hour12: true }).replace(/\s?(am|pm)$/i, (m) => ` ${m.trim().toUpperCase()}`);
  }
  const diffDays = Math.floor((now - d) / 86400000);
  if (diffDays <= 1) return "Yesterday";
  if (diffDays < 7) return d.toLocaleDateString("en-IN", { weekday: "short" });
  return d.toLocaleDateString("en-IN", { day: "numeric", month: "short" });
}

function StatusTick({ message }) {
  if (message?.direction !== "Outgoing") return null;
  switch (message?.status) {
    case "Read": return <CheckCheck size={14} className="wa-tick is-read" aria-label="Read" />;
    case "Delivered": return <CheckCheck size={14} className="wa-tick" aria-label="Delivered" />;
    case "Sent": return <Check size={14} className="wa-tick" aria-label="Sent" />;
    case "Failed": return <Clock3 size={13} className="wa-tick is-failed" aria-label="Not sent" />;
    default: return <Clock3 size={13} className="wa-tick" aria-label="Sending" />;
  }
}

function ConversationListItem({ conversation, isActive, onSelect }) {
  const { contact, last_message, unread_count = 0, assigned_user } = conversation;
  const tags = Array.isArray(contact?.tags) ? contact.tags : [];
  const timestamp = last_message?.meta_timestamp || conversation.last_message_at || conversation.updated_at;
  const preview = last_message?.preview?.trim() || "No messages yet";
  const name = capitalizeName(contact?.name || contact?.phone_number || "Unknown customer");
  const unread = Number(unread_count) > 0;

  return (
    <button
      type="button"
      onClick={() => onSelect(conversation)}
      aria-pressed={isActive}
      className={`wa-chat-item${isActive ? " is-active" : ""}${unread ? " is-unread" : ""}`}
    >
      <Monogram name={name} size={40} />
      <span className="wa-chat-item-body">
        <span className="wa-chat-item-top">
          <strong className="wa-ellipsis">{name}</strong>
          <span className="wa-chat-item-time">{listTime(timestamp)}</span>
        </span>
        <span className="wa-chat-item-line">
          <StatusTick message={last_message} />
          <span className="wa-ellipsis">{preview}</span>
          {unread && <span className="wa-unread ws-num" aria-label={`${unread_count} unread`}>{unread_count > 99 ? "99+" : unread_count}</span>}
        </span>
        {(tags.length > 0 || assigned_user) && (
          <span className="wa-chat-item-meta">
            {tags.slice(0, 2).map((tag) => (
              <span key={tag.id} className="wa-chat-tag" style={{ "--tag": tag.color || "#147DB5" }}>{tag.name}</span>
            ))}
            {tags.length > 2 && <span className="wa-chat-more">+{tags.length - 2}</span>}
            {assigned_user && <span className="wa-chat-owner" title={`Assigned to ${assigned_user.name}`}><UserRound size={11} aria-hidden="true" />{assigned_user.name?.split(" ")[0]}</span>}
          </span>
        )}
      </span>
    </button>
  );
}

export default ConversationListItem;
